import * as L from "leaflet";
import { Fab, Portal, Tooltip } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { Emission, EmissionFeatureCollection } from "src/types";
import { usePointSourceEmissionDraw } from "src/hooks/usePointSourceEmissionDraw";

enum MapMode {
  DRAW = "DRAW",
  SELECT = "SELECT",
}

interface Props {
  map: L.Map;
  controlContainer: Element | null;
  emission: Emission;
  disabled: boolean;
  onSelect: (feature: EmissionFeatureCollection) => void;
  onDraw: (point: L.LatLngLiteral) => void;
}

export const PointSourceControlOnMap = (props: Props) => {
  const { t } = useTranslation();
  const { mapMode, toggleMapMode } = usePointSourceEmissionDraw(props.map, props.emission, {
    onSelect: props.onSelect,
    onDraw: props.onDraw,
  });

  function defineFabColor() {
    if (mapMode === MapMode.DRAW) return "primary";
    // else
    return "default";
  }

  // render the component
  return render();

  function render() {
    return (
      <Portal container={props.controlContainer}>
        <Tooltip
          title={mapMode === MapMode.SELECT ? t<string>("label.addEmissionSegment") : t<string>("label.cancel")}
          placement="right"
        >
          <span>
            <Fab
              color={defineFabColor()}
              size="medium"
              disabled={props.disabled}
              onDoubleClick={(event) => event.stopPropagation()}
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                toggleMapMode();
                return false;
              }}
            >
              <AddIcon fontSize="small" />
            </Fab>
          </span>
        </Tooltip>
      </Portal>
    );
  }
};
